var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"transition-overlay"},[_c('div',{staticClass:"transition-overlay__content"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.message))]})],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }